<template>
  <div>
    <DrawerToolbar
      ref="drawerToolbar"
      :navItems="drawerItems"
      :user="user"
      :show-invoice="showInvoice"
    />
    <v-main>
      <v-container>
        <v-fade-transition mode="out-in">
          <slot />
        </v-fade-transition>
      </v-container>
    </v-main>
    <Footer :connection="connection" />
  </div>
</template>

<script>
import DrawerToolbar from '@/components/Ui/DrawerToolbar'
import Footer from '@/components/Ui/Footer'
import i18n from '@/plugins/i18n'
import store from '@/store'
import firebaseTagNames from '@/constants/firebaseTagNames'
import {
  wampUtils,
  ConnectionWSShared,
  firebaseServices,
  magentaOAuth
} from '@leapsight/styleguide'

export default {
  name: 'App',
  components: {
    DrawerToolbar,
    Footer
  },
  methods: {
    onUpdateUserData(e) {
      this.userData = e.detail
    },
    showInvoice() {
      return (
        store.getters['auth/userIsAdmin'] &&
        store.getters['auth/accountInformation'].country_id === 'AR'
      )
    }
  },
  computed: {
    connection() {
      return this.$store.getters['auth/connection']
    },
    user() {
      const storedUser = JSON.parse(localStorage.getItem('user'))
      const name = storedUser ? storedUser.name : ''
      const storedLastName = JSON.parse(localStorage.getItem('user'))
      const last_name = storedLastName ? storedLastName.last_name : ''
      return {
        name:
          this.$store.state.auth.user.first_name || this.userData.name || name,
        last_name:
          this.$store.state.auth.user.last_name ||
          this.userData.last_name ||
          last_name,
        avatarImage: this.$store.state.auth.user.photo
      }
    }
  },
  data: () => ({
    userLayout: {},
    userData: {},
    drawerItems: [
      {
        icon: 'icon_home',
        text: i18n.t('portal.general.drawer_toolbar.labels.home'),
        to: { name: 'launcher' },
        id: 'idPortalInicio'
      },
      {
        icon: 'icon_account_settings',
        text: i18n.t('portal.general.drawer_toolbar.labels.account_settings'),
        to: { name: 'account-settings' },
        logEvent: () => {
          firebaseServices.logEvent(
            firebaseServices.analytics,
            firebaseTagNames.BTN_PORTAL_SIDEBAR_MENU_ACCOUNT_SETTINGS
          )
        },
        id: 'idPortalConfiguracionDeCompania'
      },
      {
        icon: 'icon_user_settings',
        text: i18n.t('portal.general.drawer_toolbar.labels.user_settings'),
        to: { name: 'user-settings' },
        id: 'idPortalCuenta'
      }
    ]
  }),
  created() {
    if (store.getters['auth/isLoggedIn']) {
      store.dispatch('auth/checkTokenIsActive').then(response => {
        //Permito seguir si el token es válido y se encuentra logueado
        ConnectionWSShared.isConnectionOpen() &&
          store.dispatch('auth/getConnection', {})
        const connection = store.getters['auth/connection']
        const topic = 'com.magenta.device.deleted'
        const callback = response => {
          if (
            response[0].info.identifier ===
            localStorage.getItem('DEVICE_IDENTIFIER')
          ) {
            wampUtils.TokenServices.clearToken()
            store.commit(
              'ui/setDisconnectDialogMessage',
              i18n.t('general.disconnectDialogComponent.message_deleted_device')
            )
            store.commit('ui/setDisconnectDialogValue', true)
            setTimeout(() => store.dispatch('auth/logout'), 10000)
          }
        }
        switch (response) {
          case true:
            connection.session.subscribe(topic, callback, { match: 'exact' })
            if (store.getters['auth/wsConnectionActive'] === false) {
              if (!this.connection?.session?.isOpen)
                store.dispatch('auth/establishConnection')
            }
            break
          case false:
            magentaOAuth
              .refreshToken()
              .then(response => {
                if (response.status === 200) {
                  store.dispatch('auth/establishConnection')
                } else {
                  store.dispatch('auth/logout')
                }
              })
              .catch(() => {
                store.dispatch('auth/logout')
              })
            break
        }
      })
    }
  },
  mounted() {
    window.addEventListener('update-people-data', this.onUpdateUserData)
  },
  destroyed() {
    window.removeEventListener('update-people-data', this.onUpdateUserData)
  }
}
</script>

<style lang="scss" scoped></style>
